import keycloak from '../keycloak';

const BASE = process.env.REACT_APP_API_BASE_URL || '/api';

async function request(path, options = {}) {
  try {
    await keycloak.updateToken(30);
  } catch {
    throw new Error('Sitzung abgelaufen. Bitte neu anmelden.');
  }
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${keycloak.token}`,
    },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || res.statusText);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  stores: {
    list:         ()           => request('/stores'),
    get:          (id)         => request(`/stores/${id}`),
    create:       (data)       => request('/stores', { method: 'POST', body: JSON.stringify(data) }),
    setActive:    (id, active)      => request(`/stores/${id}/active`,    { method: 'PATCH', body: JSON.stringify({ is_active: active }) }),
    setDeliverer: (id, delivererId) => request(`/stores/${id}/deliverer`, { method: 'PATCH', body: JSON.stringify({ deliverer_id: delivererId ?? null }) }),
    setBillingFlags: (id, flags)    => request(`/stores/${id}/billing-flags`, { method: 'PATCH', body: JSON.stringify(flags) }),
    update:       (id, data)   => request(`/stores/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  },
  openingHours: {
    list:   ()         => request('/opening-hours'),
    get:    (id)       => request(`/opening-hours/${id}`),
    create: (data)     => request('/opening-hours', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => request(`/opening-hours/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id)       => request(`/opening-hours/${id}`, { method: 'DELETE' }),
  },
  addresses: {
    list:   ()         => request('/addresses'),
    get:    (id)       => request(`/addresses/${id}`),
    create: (data)     => request('/addresses', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => request(`/addresses/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id)       => request(`/addresses/${id}`, { method: 'DELETE' }),
  },
  contacts: {
    list:   ()         => request('/contacts'),
    get:    (id)       => request(`/contacts/${id}`),
    create: (data)     => request('/contacts', { method: 'POST', body: JSON.stringify(data) }),
    update: (id, data) => request(`/contacts/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete: (id)       => request(`/contacts/${id}`, { method: 'DELETE' }),
  },
  deliverers: {
    list:            ()         => request('/deliverers'),
    get:             (id)       => request(`/deliverers/${id}`),
    create:          (data)     => request('/deliverers', { method: 'POST', body: JSON.stringify(data) }),
    createFromStore: (data)     => request('/deliverers/from-store', { method: 'POST', body: JSON.stringify(data) }),
    setActive:       (id, active) => request(`/deliverers/${id}/active`, { method: 'PATCH', body: JSON.stringify({ is_active: active }) }),
    update:          (id, data) => request(`/deliverers/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
    delete:          (id)       => request(`/deliverers/${id}`, { method: 'DELETE' }),
    createContact:   (id)       => request(`/deliverers/${id}/contact`, { method: 'POST', body: '{}' }),
  },
  images: {
    list:   (storeId)              => request(`/stores/${storeId}/images`),
    upload: (storeId, type, data)  => request(`/stores/${storeId}/images/${type}`, { method: 'POST', body: JSON.stringify(data) }),
    delete: (storeId, type)        => request(`/stores/${storeId}/images/${type}`, { method: 'DELETE' }),
  },
};
